<script>
import layout from '@src/mixins/layout.vue'

import { authComputed, navComputed, navMethods } from '@state/helpers'

export default {
  mixins: [layout],
  data() {
    return {
      org: null,
      displayFilter: false,
    }
  },
  computed: {
    ...authComputed,
    ...navComputed,
    logoComputed() {
      return this.$style.logoContainer
    },
    menuItems() {
      return [
        {
          icon: 'settings',
          name: this.$t('user-menu.settings'),
          route: 'settings.profile',
        },
        {
          icon: 'logout',
          name: this.$t('user-menu.logout'),
          route: 'safeHavenLogout',
        },
      ]
    },
  },
  mounted() {
    this.getOrg()
  },
  methods: {
    ...navMethods,
    toggleDrawer(drawer) {
      this.displayFilter = false
      document.getElementById('updateCalneder').click()
      this.setDrawer({
        value: !this.getDrawer(drawer),
        drawer: drawer,
      })
    },
    getOrg() {
      this.org = this.currentUser.user.user_org_details[0]
    },
  },
}
</script>

<template>
  <v-app-bar
    v-if="org"
    :height="$vuetify.breakpoint.mdAndUp ? 76 : 55"
    color="white"
    clipped-left
    expand-on-hovers
    clipped
    elevate-on-scroll
    clipped-right
    elevation="1"
    app
  >
    <div class="d-flex flex-grow-1 align-center" :class="$style.mobilemenu">
      <v-app-bar-nav-icon
        color="offblack"
        @click.stop="toggleDrawer('navDrawer')"
      ></v-app-bar-nav-icon>

      <div :class="logoComputed">
        <router-link :to="{ name: 'safehaven-dashboard' }">
          <v-img
            v-if="org"
            :height="$vuetify.breakpoint.mdAndUp ? 54 : 45"
            contain
            :class="[
              $style.logoImg,
              org.org_short_name === 'healthbook' ? 'healthbook' : 'safehaven',
            ]"
            :src="org.org_logo"
          ></v-img>
        </router-link>
      </div>
    </div>
    <v-row no-gutters class="justify-end px-5 mobilespaceclss">
      <v-spacer></v-spacer>
      <div :class="$style.actionBtns">
        <router-link :to="{ name: 'connection-hub' }">
          <v-btn :class="[$style.connectionHubActionBtn]">
            <v-img
              :class="[$style.actionBtnImg]"
              :src="require('@assets/images/safehaven/connection_hub.svg')"
            ></v-img>
            Connection Hub
          </v-btn>
        </router-link>

        <router-link :to="{ name: 'health-help' }">
          <v-btn :class="$style.healthHelpActionBtn">
            <v-img
              :class="[$style.actionBtnImg]"
              :src="require('@assets/images/safehaven/health_help.svg')"
            ></v-img>
            Get HB+ Help
          </v-btn>
        </router-link>
      </div>

      <v-tooltip v-if="!mobile" bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            :input-value="getDrawer('calendarDrawer')"
            style="padding: 20px 20px 23px 20px"
            color="#294c74"
            icon
            :x-large="!mobile"
            :small="mobile"
            v-on="on"
            @click="toggleDrawer('calendarDrawer')"
          >
            <v-img
              max-width="37"
              style="margin-top: 3px"
              :src="require('@assets/images/safehaven/broadcast.svg')"
            ></v-img>
          </v-btn>
        </template>
        {{ $t('nav.calendar.widget.title') }}
      </v-tooltip>
      <v-menu
        v-model="displayFilter"
        :close-on-content-click="true"
        :nudge-width="200"
        :max-width="mobile ? '94%' : 200"
        class="ma-auto"
        offset-y
        align="center"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            style="padding: 20px 20px 23px 20px"
            color="#294c74"
            icon
            x-large
            v-bind="attrs"
            v-on="on"
          >
            <v-avatar
              class="mx-4"
              :class="$style.appBarAvatar"
              size="35"
              style="margin-top: 3px !important"
            >
              <v-img
                :src="currentUser.user.profile_picture || defaultProfilePhoto"
              ></v-img>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item v-if="mobile" :class="$style.listItem">
              <v-btn
                plain
                color="primary"
                class="text-capitalize"
                :class="$style.actionBtn"
                @click="toggleDrawer('calendarDrawer')"
              >
                Reminders
              </v-btn>
            </v-list-item>
            <v-list-item :class="$style.listItem">
              <v-btn
                plain
                color="primary"
                class="text-capitalize"
                :class="$style.actionBtn"
                :to="{ name: 'safehaven-profile' }"
              >
                Account Settings
              </v-btn>
            </v-list-item>
            <v-list-item :class="$style.listItem">
              <v-btn
                plain
                color="primary"
                class="text-capitalize"
                :class="$style.actionBtn"
                :to="{ name: 'safeHavenLogout' }"
              >
                Sign Out
              </v-btn>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-row>
  </v-app-bar>
</template>

<style lang="scss" module scoped>
@import '@design';

.logoContainer {
  width: 223px;
  max-width: 223px;
  height: 100%;
}

.healthbookLogoContainer {
  width: 340px !important;
  height: 100%;
}

.logoImg {
  background-position: left center;
}

.listItem {
  height: 35px;
  min-height: 0 !important;
  padding: 0 !important;
}
.actionBtn {
  justify-content: flex-start !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  letter-spacing: 0.25px;
}

.actionBtns {
  display: inline;
  padding: 8px 10px 0 0;
}
.connectionHubActionBtn {
  padding: 12px 15px !important;
  font-size: 14px !important;
  font-weight: bold;
  color: #082787 !important;
  text-transform: capitalize;
  background-color: #fff !important;
  border: 0;
  box-shadow: none;
}

.healthHelpActionBtn {
  padding: 12px 15px !important;
  font-size: 14px !important;
  font-weight: bold;
  color: #f9fafb !important;
  text-transform: capitalize;
  background: linear-gradient(180deg, #84b25a 0%, #698e48 100%);
}
.actionBtnImg {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}
@media screen and (max-width: 960px) {
  .logoContainer {
    width: 185px;
    max-width: 185px;
  }
}
@media screen and (max-width: 800px) {
  .actionBtns {
    display: none;
  }
}
@media screen and (max-width: 599px) {
  .mobilemenu {
    justify-content: space-between !important;
  }
  .mobilehide {
    display: none !important;
  }
}
@media screen and (max-width: 370px) {
  .logoContainer {
    width: 200px;
    max-width: 200px;
  }
}
@media screen and (max-width: 310px) {
  .logoContainer {
    width: 130px;
    max-width: 130px;
  }
}
</style>

<style scoped>
@media screen and (max-width: 400px) {
  /deep/ .px-5.mobilespaceclss {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .spacer {
    display: none !important;
  }
}
@media screen and (max-width: 370px) {
  /deep/ .v-toolbar__content {
    padding: 4px 8px !important;
  }
  /deep/.safehaven .v-image__image--cover {
    background-size: contain !important;
  }
}
@media screen and (max-width: 365px) {
  /deep/ .px-5.mobilespaceclss {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media screen and (max-width: 330px) {
  /deep/ .v-toolbar__content,
  .v-toolbar__extension {
    padding: 4px 4px;
  }
}
</style>
